exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal-footer{text-align:center}.bc-e9ecef{background-color:#e9ecef;opacity:1}.vb-m{letter-spacing:1px}.vb,.vb-m{display:table-cell;font-weight:600;text-align:left}.vb{letter-spacing:-.42px}.info_membership{justify-content:space-between;display:flex;border-bottom:.01px solid #c6c6c6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b7c1fb2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/MyInfo.vue
// module id = 260
// module chunks = 0